import React from 'react';
import ReactHtml from 'components/shared/ReactHtml';

const ConditionalList = ({ list }) => {
  if (list.length === 1) {
    return (
      <p className="ws-pl">
        <ReactHtml component="span">{list[0]}</ReactHtml>
      </p>
    );
  }
  return (
    <p className="ws-pl">
      <ul>
        {list.map(item => (
          <li key={item}>
            <ReactHtml component="span">{item}</ReactHtml>
          </li>
        ))}
      </ul>
    </p>
  );
};

export default ConditionalList;
